import React from "react";
import { Carousel } from 'react-bootstrap';
import "./scholarshipProgramme.css";

import Simg1 from '../../assets/Pathway.jpg';
import Simg2 from '../../assets/courseheaderimg1.png';
import Simg3 from '../../assets/courseheaderimg2.png';
import Simg4 from '../../assets/courseheaderimg3.png';

function ScholarshipProgramme() {
  return (
    <>
      {/* Banner */}
      <div className="banner-certificate">
        <Carousel className="mb-5">
          <Carousel.Item>
            <img className="d-block w-100" src={Simg1} alt="slide1" />
          </Carousel.Item>
          <Carousel.Item>
            <img className="d-block w-100" src={Simg2} alt="slide2" />
          </Carousel.Item>
          <Carousel.Item>
            <img className="d-block w-100" src={Simg3} alt="slide3" />
          </Carousel.Item>
          <Carousel.Item>
            <img className="d-block w-100" src={Simg4} alt="slide4" />
          </Carousel.Item>
        </Carousel>
      </div>

      {/* Main Content */}
      <div className="certificate-container">
        <div className="header">
          <h1>Scholarship Programme 2026</h1>
          <p>
            Kickstart your career in Optometry with Eye Care Institute (ECI Campus).
            This exclusive scholarship program provides financial support,
            professional training, and a guaranteed career pathway in the eye care industry.
          </p>
        </div>

        {/* Field */}
        {/* <div className="section">
          <h2>Field of Study</h2>
          <p><strong>Optometry</strong></p>
        </div> */}

        {/* Scholarship Benefits */}
        <div className="section">
          <h2>Scholarship Benefits</h2>
          <ul>
            <li>100% Free Tuition Fees</li>
            <li>Transport Allowance Provided</li>
            <li>Food Allowance Included</li>
            <li>Hands-on Clinical Training</li>
            <li>Mentorship from Industry Professionals</li>
            <li>Career Guidance & Skill Development</li>
          </ul>
        </div>

        {/* Programs */}
        <div className="section">
          <h2>Available Programmes</h2>
          <ul>
            <li>Certificate in Ophthalmic Assistant</li>
            <li>Diploma in Optometry</li>
            <li>Higher Diploma in Optometry</li>
          </ul>
        </div>

        {/* Career */}
        <div className="section">
          <h2>Career Opportunities</h2>
          <p>
            Optometry is one of the <b> highest-paid healthcare professions </b> 
             globally and in Sri Lanka. This programme prepares you for a stable,
            respected, and rewarding career in the medical field.
          </p>
        </div> 

        {/* Guarantee */}
        <div className="section">
          <h2>Job Guarantee</h2>
          <p>
           <b>100% Job Guaranteed</b> upon successful completion of the course.
          </p>
        </div>

        {/* Conditions */}
        <div className="section">
          <h2>Conditions</h2>
          <p>Scholarship terms & conditions apply</p>
        </div>
      </div>

      {/* Apply Section */}
      <div className="how-to-apply-container">
        <h2 className="section-title">How to Apply</h2>

        <div className="steps-container">
          <div className="step">
            <div className="circle orange">
              <span>&#x270F;</span>
            </div>
            <h3 className="step-title">REGISTER NOW</h3>
            <p>
              <a href="/registration-course" style={{ textDecoration: 'none' }}>
                Apply for Scholarship
              </a>
            </p>
          </div>
        </div>



        <div className="contact-us">
          <a href="/contactus" className="contact-button text-decoration-none">
            Contact Us <span>&#x2192;</span>
          </a>
        </div>
      </div>
    </>
  );
}

export default ScholarshipProgramme;